
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { SolutionsSection } from './components/SolutionsSection';
import { CheckTeaserSection } from './components/CheckTeaserSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function HomePage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />

      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <HeroSection />
        <StatsSection />
        <HowItWorksSection />
        <SolutionsSection />
        <CheckTeaserSection />
        <AboutSection />
        <ContactSection />
        <FooterSection />
      </div>
    </div>
  );
}
